<template>
  <div>
    <h3>Attributes:</h3>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="value" label="参数" width="150"> </el-table-column>
      <el-table-column prop="describe" label="说明" width="150"> </el-table-column>
      <el-table-column prop="type" label="类型" width="200"> </el-table-column>
      <el-table-column prop="Option" label="可选值" width="150"> </el-table-column>
      <el-table-column prop="default" label="默认值" width="150"> </el-table-column>
      <el-table-column prop="required" label="必填" width="50"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          value: " paddingTypeFlag",
          describe: "边距类型",
          type: "Number",
          Option: "-",
          default: "1",
          required: "false"
        },
        {
          value: "  paddingName",
          describe: "边距title",
          type: "String",
          Option: "-",
          default: "内边距",
          required: "false"
        },
        {
          value: " padding",
          describe: "边距",
          type: "String/Number/Array",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " paddingTop",
          describe: "上边距",
          type: "String/Number",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " paddingRight",
          describe: "右边距",
          type: "String/Number",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " paddingBottom",
          describe: "下边距",
          type: "String/Number",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " paddingLeft",
          describe: "左边距",
          type: "String/Number",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " sliderMax",
          describe: "边距最大值",
          type: "Number",
          Option: "-",
          default: "-",
          required: "false"
        }
      ]
    }
  }
}
</script>

<style></style>
